import { RouteObject } from 'react-router';

import { SettingsContainer } from './containers/SettingsContainer';

const routes: RouteObject[] = [
    {
        path: 'settings',
        element: <SettingsContainer />,
    },
];

export default routes;
